exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-b3954f2a]{font-size:14px}.item[data-v-b3954f2a]{margin-bottom:18px}.clearfix[data-v-b3954f2a]:after,.clearfix[data-v-b3954f2a]:before{display:table;content:\"\"}.clearfix[data-v-b3954f2a]:after{clear:both}.full-screen-container[data-v-b3954f2a]{max-width:100%;margin:0}", ""]);

// exports
